import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=469fa6b0&scoped=true&"
import script from "./issue.vue?vue&type=script&lang=ts&"
export * from "./issue.vue?vue&type=script&lang=ts&"
import style0 from "./issue.vue?vue&type=style&index=0&id=469fa6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469fa6b0",
  null
  
)

export default component.exports